import React from "react";
import { useTranslation } from "react-i18next";
import { FaMedal } from "react-icons/fa";

export const Formacion = () => {
  const [t] = useTranslation("global");

  return (
    <div className="flex flex-col justify-center items-center  bg-gray-50">
      <h2 className="text-center text-gray-800 font-Montserrat font-bold text-2xl">
        {t("formacion")}
      </h2>
      <br />
      <br />
      <div className="px-5 w-90/0 tabletbig:w-1/2 h-1/2 ring-2 ring-gray-400 rounded-md bg-white shadow-xl">
        <div className="text-gray-800 text-smt left-2 tabletbig:w-3/5 tabletbig:text-2s  tabletbig:left-32 bg-white font-Poppins font-semibold flex justify-center items-center -top-4 relative">
          {t("ing")}
        </div>
        <img loading='lazy' src={"https://res.cloudinary.com/devsing/image/upload/v1654288814/Portfolio/images_mucjs4.png"} alt="unan" className="w-24 tabletbig:w-44 relative float-left" />
        <br />
        <p className="text-center relative text-smt right-12 tabletbig:right-24 tabletbig:text-2s  text-gray-800 font-Poppins">
          {t("Profesional")}
        </p>
        <br />
        <p className="text-center relative text-smt right-0 tabletbig:right-24 tabletbig:text-2s text-gray-500 font-Poppins">
          (2016-2021)
        </p>
        <p className="text-center text-gray-800 font-Poppins font-semibold text-smt tabletbig:text-2s">
          {t("unan")}
        </p>
        <br />

        <p className="text-center text-gray-800 font-Poppins text-smt tabletbig:text-2s">
         {t("enfasis")}
        </p>
        <br />
        <div className="flex justify-center items-center">
          <FaMedal className="text-yellow-400 text-smt tabletbig:text-2xl" />
          <p className="text-center text-gray-800 font-Poppins mx-5">
            Kevin Yamil García López
          </p>
        </div>
        <br />
      </div>
    </div>
  );
};
